import React from 'react';
import RoleManagement from '../layout/private/RoleManagement';

const RoleManagementPage = () => {
  return <RoleManagement />;
};

export default RoleManagementPage;
